import { type ComponentTFunction } from '@pkgs/components/providers/AppContextProvider';
import { Headline } from '@ev-tech/ui-core-components/Headline';
import { Copy } from '@ev-tech/ui-core-components/Copy';
import { Button } from '@ev-tech/ui-core-components/Button';

import { type ImageComponent as ImageComponentType } from '../Image/DefaultImageComponent';

import styles from './SearchAlertSignInCard.module.css';

type SearchAlertSignInCardProps = {
  t: ComponentTFunction;
  ImageComponent: ImageComponentType;
  onClick: () => void;
};

export const SearchAlertSignInCard = ({ t, ImageComponent, onClick }: SearchAlertSignInCardProps) => (
  <article className={styles.card}>
    <ImageComponent
      src="https://uploadcare.engelvoelkers.com/2ab281eb-28d7-4300-b85c-b77beab2d31e/"
      alt={t('userAccount.advertisementBanner.imageAlt')}
      width={120}
      height={76}
    />
    <div className={styles.text}>
      <Headline size="h6" as="h3" label={t('userAccount.signInModal.signIn.savedSearch.headline')} />
      <Copy size="m" text={t('userAccount.signInModal.benefits.description')} />
    </div>
    <Button size="small" label={t('userAccount.advertisementBanner.buttonLabel')} onClick={onClick} />
  </article>
);
